import { Link } from "react-router-dom";
import { BrandImg } from "./NewsCard";
import { articlePath } from "@/lib/api";

export function InlineRecommended({ items, idx }) {
  if (!items.length) return null;
  return (
    <aside data-testid={`inline-recommended-${idx}`} className="not-prose my-10 border-y-2 border-foreground py-5 font-sans">
      <p className="mb-4 font-mono-meta text-[11px] font-bold uppercase tracking-widest text-primary">Recomendado para si</p>
      <div className="space-y-4">
        {items.map((a) => (
          <Link key={a.id} to={articlePath(a)} data-testid={`inline-rec-item-${a.id}`} className="group flex items-center gap-4">
            <div className="aspect-video w-24 shrink-0 overflow-hidden rounded-lg bg-muted"><BrandImg a={a} w={320} className="img-zoom" /></div>
            <div className="min-w-0">
              <p className="font-mono-meta text-[10px] uppercase text-muted-foreground">{a.source}</p>
              <p className="font-serif-display text-base font-bold leading-snug group-hover:text-primary line-clamp-2" style={{ fontFamily: "'Playfair Display', serif" }}>{a.title}</p>
            </div>
          </Link>
        ))}
      </div>
    </aside>
  );
}
